import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface LabCultureResultHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface LabCultureResultHeader {
    id?: number;
    
    name:string;
    isActive:string;
    
  parameters?: LabCultureResultHeaderParameter[];
  links?: any;
}

export abstract class LabCultureResultHeaderData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<LabCultureResultHeader[]>;
  abstract create(url: string,data: LabCultureResultHeader): Observable<any>;
  abstract update(url: string,data: LabCultureResultHeader): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
